export default __webpack_public_path__ + "static/CBC-a256e7c476669745b0d0b49e75bd3a12.png";